<template>
    <div>
        <gofix-table
                class="noFullHeight scrollAbsolute"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="openModal"
                @row-click="openModal"
                @delete-items="deleteItems"
                ref="gofixTable">
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-20">
                <gofix-form-input label="Reason" v-model="modal.data.reference_value_text" required></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: 'settings-reasons-part-replacement',
        components: {
        },
        data () {
            return {
                tableConfig:{
                    name: 'settings-reasons-part-replacement',
                    controls:{
                        createTooptip:"Create Reason",
                    },
                    filter: {
                       reference_value_text: { type: "text", value: "", function: "ilike", with: [] },
                       reference_type: { type: 'text', value: "Part Replacement Reason Code for Rejection", function:"=", with: [] },
                       contract_id: { type: "number", value: this.$route.params.id, function: "=", with: [] },
                    },
                    page: 1,
                    total: 0,
                    //isCMS: false,
                    useDatabaseView: false,
                    sortColumn: "reference_value_text",
                    sortDirection: "asc",
                    itemSelected: [],
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'reference_value_text',
                            label: 'Reason',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:nullpx",
                            sorting: true,
                        },
                    ]
                },
                tableItems:[],
                modal:{
                    open: false,
                    loading: false,
                    title:"New Reason",
                    data:{
                        id: null,
                        reference_type: "Part Replacement Reason Code for Rejection",
                        reference_value_text: null,
                        contract_id: this.$route.params.id,
                    },
                },
            }
        },
        created() {},
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.$route.params.id;
                await this.$store.dispatch("ReferenceController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },

            //Open modal Edit || Create data
            openModal(item){
                if(item){
                    this.modal.title = "Edit Reason";
                    this.modal.data = {
                        id: item.id,
                        reference_type: item.reference_type,
                        reference_value_text: item.reference_value_text,
                        contract_id: this.$route.params.id,
                    }
                } else{
                  this.modal.title = "New Reason";
                    this.modal.data = {
                        id: null,
                        reference_type: "Part Replacement Reason Code for Rejection",
                        reference_value_text: null,
                        contract_id: this.$route.params.id,
                    }
                }
                this.modal.open = true;
            },

            //Update & Create data
            save(){
                if(!this.modal.data.reference_value_text){
                    return this.$bvToast.toast('Reason is a required field.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                let method    = 'createItem';
                let msg    = 'added';
                if(this.modal.data.id) {
                    method = 'updateItem';
                    msg    = 'updated';
                }
                this.$store.dispatch(`ReferenceController/${method}`, this.modal.data)
                    .then(result => {
                        this.$bvToast.toast( `Successfully ${msg} part replacement reason code for rejection`, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        if(error.response && error.response.data.error.message.error) {
                            return this.$bvToast.toast(error.response.data.error.message.error, {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    })
            },

            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ReferenceController/deleteItem", ids)
                    .then(response => {
                        resolve("Successfully deleted part replacement reason code for rejection");
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
        }
    }
</script>
